<template>
	<CForm class="main-wrapper form-standard">
		<CRow class="d-flex align-items-center mb-2">
			<CCol>
				<p class="typo-h4">
					Channel info
				</p>
			</CCol>
			<CCol class="text-right">
				<p class="typo-h4 typo-helper-text text-black-45">
					Slug ID:
					<b>
						Generate after saves
					</b>
				</p>
			</CCol>
		</CRow>
		<CRow>
			<CCol lg="12">
				<CInput
					v-model="$v.form.name.$model"
					:label="`${$t('message.channel_name')}*`"
					:is-valid="formState.name.valid"
					:invalid-feedback="formState.name.error"
					:description="formHelper.name"
				/>
			</CCol>
		</CRow>
		<CRow>
			<CCol lg="12">
				<BaseDropDown
					v-model="$v.form.type.$model"
					:options="CHANNEL_TYPE_OPTIONS"
					:label-drop-down="`${$t('message.channel_type')}*`"
					:placeholder="$t('message.selection')"
					:searchable="false"
					:is-valid="formState.type.valid"
					:invalid-feedback="formState.type.error"
					label="name"
					track-by="value"
				/>
			</CCol>
		</CRow>
		<CRow>
			<CCol lg="12">
				<CInput
					v-model="$v.form.link.$model"
					:label="$t('message.link_to_channel')"
					:is-valid="formState.link.valid"
					:invalid-feedback="formState.link.error"
					:description="formHelper.link"
				/>
			</CCol>
		</CRow>
		<CRow>
			<CCol lg="12">
				<CTextarea
					v-model="form.remark"
					:label="$t('message.remark')"
					rows="3"
				/>
			</CCol>
		</CRow>
		<BaseActionSubmit
			:is-loading="isLoading"
			:submit-text="$t('button.create')"
			:cancel-text="$t('button.cancel')"
			@onSubmit="handleSubmit"
			@onCancel="handleCancel"
		/>
	</CForm>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { required, maxLength, url } from 'vuelidate/lib/validators';
import { inputStateValid, inputStateError } from '../helpers/vuelidator';
import { getSelectedValue } from '../helpers/dropdown';
import { CHANNEL_TYPE, CHANNEL_TYPE_OPTIONS } from '../enums/channel';
import { ROUTER_NAME } from '../enums/router';

export default {
	name: 'ChannelCreate',

	data() {
		return {
			CHANNEL_TYPE_OPTIONS,
			form: {
				name: null,
				link: null,
				remark: null,
				type: getSelectedValue(CHANNEL_TYPE.ONLINE, CHANNEL_TYPE_OPTIONS), // default as `online`
			},
		};
	},

	validations: {
		form: {
			name: {
				required,
				maxLength: maxLength(255),
			},
			type: {
				required,
			},
			link: {
				url,
			},
		},
	},

	computed: {
		...mapState('channelCreate', {
			error: 'error',
			isLoading: 'isLoading',
		}),
		formState() {
			return {
				name: {
					valid: inputStateValid(this.$v.form.name),
					error: inputStateError(this.$v.form.name)(this),
				},
				type: {
					valid: inputStateValid(this.$v.form.type),
					error: inputStateError(this.$v.form.type)(this),
				},
				link: {
					valid: inputStateValid(this.$v.form.link),
					error: inputStateError(this.$v.form.link)(this),
				},
			};
		},
		formHelper() {
			// use IIFE becausse it's easy to use and more clearly in template
			// these properties can be null or string not an arrow function
			return {
				name: (() => {
					const isErrorMessageDisplay = this.formState.name.error !== null;
					return !isErrorMessageDisplay
						? this.$t('message.maximum_characters', { number: 255 })
						: null;
				})(),
				link: (() => {
					const isErrorMessageDisplay = this.formState.link.error !== null;
					return !isErrorMessageDisplay
						? this.$t('message.optional')
						: null;
				})(),
			};
		},
	},

	methods: {
		...mapActions('toast', {
			showToast: 'showToast',
		}),
		...mapActions('channelCreate', {
			createChannel: 'createChannel',
		}),
		async handleSubmit() {
			this.$v.$touch();

			const isValidForm = !this.$v.$invalid;

			if (isValidForm) {
				await this.createChannel({
					name: this.form.name,
					type: this.form.type.value,
					url: this.form.link,
					description: this.form.remark,
				});

				if (this.error === null) {
					// show toast with success
					this.showToast({
						header: this.$t('toast.success'),
						content: this.$t('toast.created_channel'),
						type: 'success',
					});
					// redirect to user list pages
					this.$router.push({ name: ROUTER_NAME.CHANNEL_LIST });
				} else {
					// show toast with error
					this.showToast({
						header: this.$t('toast.unable_to_save'),
						content: this.error.message,
						type: 'danger',
					});
				}
			}
		},
		handleCancel() {
			// redirect to channel list pages
			this.$router.push({ name: ROUTER_NAME.CHANNEL_LIST });
		},
	},
};
</script>